module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/node_modules/core-js/library/modules/_html.js
// module id = 55
// module chunks = 1 2 3 4